<template>
  <div>
    <div class="card p-3 mb-2" v-for="p in pedidos">
      <a href="#" class="text-muted" @click.prevent="abrirPedido(p)">
        <div class="d-flex align-items-center">
          <h6 class="mb-0 font-weight-bold text-primary">Pedido #{{p.id_contador}}</h6>
          <div class="text-primary small ml-auto">
            <span class="text-dark">Visualizar</span> <i class="fa fa-chevron-right ml-1"></i>
          </div>
        </div>
        <div>
          <p class="small m-0">{{p.nome_fantasia}} | {{p.data_pedido}}</p>
          <p class="font-weight-bold m-0 small text-danger" v-if="p.status === '5'">
            Cancelado<span v-show="p.obs_cancelamento">: {{p.obs_cancelamento}}</span>
          </p>
        </div>
      </a>
      <div class="border-top text-center mt-3 pt-3" v-if="parseInt(p.status) < 4">
        <div v-if="p.status_pagamento === '1'">
          <router-link :to="url + `/pagamento/${p.id_pedido}`" class="btn btn-block btn-primary">
            Pagar Pedido
          </router-link>
          <button class="btn btn-outline-danger btn-block" @click="solicitarCancelamento(p.id_pedido)">Cancelar Pagamento</button>
        </div>
        <router-link :to="url + `/acompanhar/${p.id_pedido}`" class="btn btn-block btn-outline-primary" v-else>
          Acompanhar Pedido
        </router-link>
      </div>
      <div class="border-top text-center mt-3 pt-3" @click="abrirPedido(p, true)" v-else-if="is_plus && parseInt(p.status) === 4">
        <button class="btn btn-block" :class="p.id_avaliacao ? 'btn-outline-primary' : 'btn-primary'">
          <span v-if="p.id_avaliacao"><i class="fa fa-check mr-1"></i> Ver Avaliação</span>
          <span v-else><i class="fa fa-star mr-1"></i> Avaliar Pedido</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Pedido",
    props: ['pedidos', 'empresa'],

    data() {
      return {
        token: localStorage.getItem('token'),
        url: '',
      }
    },

    methods: {
      abrirPedido(pedido, avaliar = false) {
        if (avaliar) {
          this.$emit('abrirPedido', pedido.id_pedido, avaliar);
          return;
        }

        const pagina = pedido.status_pagamento === '1' && parseInt(pedido.status) < 4
          ? 'pagamento'
          : 'acompanhar';

        this.$router.push(this.url + `/${pagina}/${pedido.id_pedido}`);
      },

      solicitarCancelamento(id_pedido) {
        this.$swal({
          text: 'Ao cancelar o pagamento o pedido também será cancelado. Deseja continuar?',
          buttons: ["Não", "Sim"],
          dangerMode: true,
        }).then((r) => {
          if (r) {
            this.cancelar(id_pedido);
          }
        });
      },

      cancelar(id_pedido) {
        this.$store.state.load = "Cancelando pagamento..";
        const url = this.$helpers.base_url(this, this.empresa);

        this.$http.post(url + this.token + '/meus-pedidos/cancelar', { id_pedido })
          .then(res => {
            this.$store.state.load = false;

            if (res.data && res.data.success) {
              this.$swal("Pedido cancelado com sucesso!");

            } else {
              this.$swal(res.data?.msg || 'Erro temporário');
            }

            this.$emit('atualizar');

          }, res => {
            this.$store.state.load = false;
            this.$swal(res.data?.msg || 'Erro temporário');
          });
      },
    },

    mounted() {
      this.url = this.$helpers.getUrlApp(this.$route.params.id || '');
    }
  }
</script>

<style scoped>
</style>
